import ui from "./ui-text-ru";

let config = {
  ui,
  animation: {
    fadingDuration: 500,
    reactmountdelay: 200,
    turndelay: 20
  },
  imagedir: "ui/images/",
  background: "ui/images/background.jpg",
  icons: {
    close: "ui/images/iconmonstr/iconmonstr-x-mark-1-240.png",
    "expand-form": "ui/images/arrow-right.png",
    "option-form": "ui/images/iconmonstr/iconmonstr-check-mark-15-240.png",
    wait: "ui/images/calendar/calendar.png",
    calendarDir: "ui/images/calendar/",
    lock: "ui/images/lock.png",
    role: "ui/images/iconmonstr/iconmonstr-id-card-7-240.png",
    editbtn: "ui/images/karandash-in-red-frame.png",
    msgjournal: {
      prev: "ui/images/iconmonstr/iconmonstr-arrow-left-21-240.png",
      next: "ui/images/iconmonstr/iconmonstr-arrow-21-240.png",
      last: "ui/images/iconmonstr/iconmonstr-arrow-32-240.png"
    },
    mail: {
      icon: "ui/images/mailicon.png",
      person: "ui/images/person/person_opt.svg",
      you:    "ui/images/person/person_opt_you.svg"
    }
  },
  showEditButton: true,
  urlToPostEdits: "http://xn----8sbwjgicfcodqps0m.xn--p1ai/log/log.php",
  //urlToPostEdits: "http://localhost/test/log.php",
  RefTextResolvingLog: false,
  defaultRoles: function(s) {
    if(s === "Заявитель" || s === "Разрешитель" || s === window.text.subj.Finish)
      return true;
    if(s.startsWith("Department")) return true;
    return false;
  },
  greeting: true,
  roleSelection: false
}

export default config;
